module.exports = __webpack_public_path__ + "static/media/fa-brands-400.457cb96b.woff";